import React, {ReactElement} from 'react';
import style from './style.module.scss';
import {Tooltip, TPlacesType} from 'components/Tooltip';
import Icon from 'components/Icon';
import {Typography} from 'components/Typography';

interface IInPlaceNotificationProps {
    children: ReactElement;
    text?: string;
    type: 'check';
    isVisible: boolean;
    body?: ReactElement;
    place?: TPlacesType;
    className?: string;
}

const ICONS_MAP = {
    check: <Icon icon={'checkmark-colored'} />,
};

export const InPlaceNotification = (props: IInPlaceNotificationProps) => {
    const {text, children, type, isVisible, body, place = 'bottom-start', className} = props;

    if (!isVisible) {
        return children;
    }

    const overlay = (
        <div className={style.notificationWrapper}>
            <div className={style.iconWrapper}>{ICONS_MAP[type]}</div>
            <div className={style.notificationContent}>
                <Typography variant={'label-14-r'} color={'white100'}>
                    {text}
                </Typography>
            </div>
        </div>
    );

    return (
        <Tooltip
            isOpen={isVisible}
            className={!className ? style.notificationInner : className}
            overlay={!body ? overlay : body}
            place={place}
            showArrow={false}
            positionStrategy={'fixed'}
            onClick={() => {}}
            setIsOpen={() => {}}
        >
            {children}
        </Tooltip>
    );
};
